<template>
    <div class="home">
        <div class="container home-container">
            <div class="flex gap-4">
                <div class="h1-container">

                    <h1>
                        <span class="sr-only">Faculty of Education Program Explorer</span>
                        <!-- <span class="small">Faculty of Education </span>
                        <span class="large">
                            <span class="top-span">Program</span> <br />
                            <span class="bottom-span">Explorer</span>
                        </span> -->
                        <svg xmlns="http://www.w3.org/2000/svg" width="774.002" height="490.003" viewBox="0 0 774.002 490.003" class="heading-svg">
                            <g id="FoE-Program-Explorer" transform="translate(0 0.364)">
                                <path id="White_Rectangles" data-name="White Rectangles" d="M16876-22295.361v-393h745v184h29v209Z" transform="translate(-16876 22785)" fill="#fff"/>
                                <path id="Program-Explorer" d="M72.859-8.439c9.725-3.536,17.24-9.725,17.24-26.523V-85.8c0-16.8-7.515-22.986-17.24-26.523H3.9V46.817H39.264V-8.439ZM52.525-83.587l2.21,2.21v41.995l-2.21,2.21H39.264V-83.587Zm95.04,0,2.21,2.21v35.364l-2.21,2.21H134.3V-83.587ZM134.3,46.817V-15.07h3.757L158.4,46.817h30.943V24.494L170.331-26.342c8.62-3.757,14.809-10.388,14.809-25.639V-85.8c0-16.8-7.515-22.986-17.24-26.523H98.94V46.817ZM281.948-85.8c0-16.8-7.515-22.986-17.24-26.523h-51.72c-9.725,3.536-17.24,9.725-17.24,26.523V20.294c0,16.8,7.515,22.986,17.24,26.523h51.72c9.725-3.536,17.24-9.725,17.24-26.523ZM246.584,15.874l-2.21,2.21H233.323l-2.21-2.21v-97.25l2.21-2.21h11.051l2.21,2.21ZM361.958,46.817c9.725-3.536,17.24-9.725,17.24-26.523V-46.013h-44.2v33.154h8.841V15.874l-2.21,2.21H330.573l-2.21-2.21v-97.25l2.21-2.21h11.051l2.21,2.21v22.1H379.2V-85.8c0-16.8-7.515-22.986-17.24-26.523h-51.72C300.514-108.784,293-102.595,293-85.8V20.294c0,16.8,7.515,22.986,17.24,26.523Zm76.916-130.4,2.21,2.21v35.364l-2.21,2.21H425.613V-83.587Zm-13.261,130.4V-15.07h3.757L449.7,46.817h30.943V24.494L461.64-26.342c8.62-3.757,14.809-10.388,14.809-25.639V-85.8c0-16.8-7.515-22.986-17.24-26.523H390.25V46.817ZM527.947-67.452h2.21l4.42,50.172H523.527ZM540.1,46.817h33.154V20.073L553.144-112.32H504.961L484.848,20.073V46.817H518l2.652-30.943h16.8Zm87.3-55.256h26.523L664.982-43.8h1.105v90.62h33.154V-112.32H660.562L641.775-57.064h-2.21L620.777-112.32H582.1V46.817h33.154V-43.8h1.105ZM3.9,231H77.943V197.85H39.264V166.907H74.628V133.753H39.264V105.02H76.838V71.866H3.9Zm125.984-56.8h2.21L142.04,231h33.154V204.26l-17.019-52.825L175.193,98.61V71.866H142.04l-9.946,56.8h-2.21l-9.946-56.8H86.784V98.61L103.8,151.435,86.784,204.26V231h33.154Zm123.11,1.547c9.725-3.536,17.24-9.725,17.24-26.523V98.389c0-16.8-7.515-22.986-17.24-26.523H184.034V231H219.4V175.748ZM232.66,100.6l2.21,2.21V144.8l-2.21,2.21H219.4V100.6ZM279.075,231h71.833V197.85H314.438V71.866H279.075ZM444.842,98.389c0-16.8-7.515-22.986-17.24-26.523h-51.72c-9.725,3.536-17.24,9.725-17.24,26.523V204.481c0,16.8,7.515,22.986,17.24,26.523H427.6c9.725-3.536,17.24-9.725,17.24-26.523ZM409.479,200.06l-2.21,2.21H396.217l-2.21-2.21V102.81l2.21-2.21h11.051l2.21,2.21Zm95.04-99.461,2.21,2.21v35.364l-2.21,2.21H491.257V100.6ZM491.257,231V169.117h3.757L515.349,231h30.943V208.68l-19.008-50.835c8.62-3.757,14.809-10.388,14.809-25.639V98.389c0-16.8-7.515-22.986-17.24-26.523H455.894V231Zm61.445,0h74.043V197.85H588.066V166.907H623.43V133.753H588.066V105.02H625.64V71.866H552.7ZM686.421,100.6l2.21,2.21v35.364l-2.21,2.21H673.16V100.6ZM673.16,231V169.117h3.757L697.251,231h30.943V208.68l-19.008-50.835c8.62-3.757,14.809-10.388,14.809-25.639V98.389c0-16.8-7.515-22.986-17.24-26.523H637.8V231Z" transform="translate(20.044 233.713)" fill="#cc0633"/>
                                <rect id="Red_Rectangle" data-name="Red Rectangle" width="619" height="97" transform="translate(0 -0.364)" fill="#A6192E"/>
                                <path id="FoE" d="M25.466-34.725H2.695v49.43h9.858V-5.775H23.661v-8.886H12.553V-25.838H25.466Zm-2.083,49.43H33.658L35.255,7H46.64l1.6,7.706H58.512l-12.7-49.43H36.088ZM37.129-1.887l3.818-18.328L44.766-1.887ZM74.757-35.28a12.977,12.977,0,0,0-10.83,5c-3.471,4.235-3.679,10.761-3.679,20.272s.208,16.037,3.679,20.272a12.977,12.977,0,0,0,10.83,5,12.889,12.889,0,0,0,9.511-3.541C86.837,9.29,88.5,5.333,88.711.612H78.853a9.363,9.363,0,0,1-.764,3.818,3.3,3.3,0,0,1-3.332,1.944,3.394,3.394,0,0,1-3.332-1.944c-1.18-2.291-1.319-8.47-1.319-14.44s.139-12.149,1.319-14.44a3.394,3.394,0,0,1,3.332-1.944,3.252,3.252,0,0,1,3.332,1.874,9.363,9.363,0,0,1,.764,3.818h9.858c-.208-4.721-1.874-8.609-4.443-11.038A12.889,12.889,0,0,0,74.757-35.28Zm47.417.555h-9.858V1.168c0,3.749-1.458,5.207-4.1,5.207s-4.1-1.458-4.1-5.207V-34.725H94.265V1.445a13.593,13.593,0,0,0,3.679,9.719,14.935,14.935,0,0,0,20.55,0,13.593,13.593,0,0,0,3.679-9.719Zm17.148,0h-9.858v49.43h22.771V5.819H139.322Zm39.016,0h-26.52v8.886h8.331V14.705h9.858V-25.838h8.331Zm33.74,0h-10.83l-4.165,17.911-4.165-17.911h-10.83L192.153-3.9V14.705h9.858V-3.9Zm28.6,49.985a12.977,12.977,0,0,0,10.83-5c3.471-4.235,3.679-10.761,3.679-20.272s-.208-16.037-3.679-20.272a12.977,12.977,0,0,0-10.83-5,12.977,12.977,0,0,0-10.83,5c-3.471,4.235-3.679,10.761-3.679,20.272s.208,16.037,3.679,20.272A12.977,12.977,0,0,0,240.681,15.261Zm0-8.886a3.394,3.394,0,0,1-3.332-1.944c-1.18-2.291-1.319-8.47-1.319-14.44s.139-12.149,1.319-14.44a3.394,3.394,0,0,1,3.332-1.944,3.394,3.394,0,0,1,3.332,1.944c1.18,2.291,1.319,8.47,1.319,14.44s-.139,12.149-1.319,14.44A3.394,3.394,0,0,1,240.681,6.374Zm43.46-41.1H261.369v49.43h9.858V-5.775h11.108v-8.886H271.228V-25.838H284.14Zm40.058,0H301.427v49.43H324.2V5.819H311.285v-11.8h11.108v-8.886H311.285V-25.838H324.2Zm6.04,0v49.43h13.954c5.554,0,8.609-2.222,10.83-4.79,3.471-3.957,3.679-10.9,3.679-19.994s-.208-15.9-3.679-19.855c-2.222-2.569-5.276-4.79-10.83-4.79Zm13.746,8.886a3.917,3.917,0,0,1,3.679,2.152c1.18,2.291,1.18,8.123,1.18,13.607s0,11.455-1.18,13.746a3.917,3.917,0,0,1-3.679,2.152H340.1V-25.838Zm48.458-8.886h-9.858V1.168c0,3.749-1.458,5.207-4.1,5.207s-4.1-1.458-4.1-5.207V-34.725h-9.858V1.445a13.593,13.593,0,0,0,3.679,9.719,14.935,14.935,0,0,0,20.55,0,13.593,13.593,0,0,0,3.68-9.719Zm20.341-.555a12.977,12.977,0,0,0-10.83,5c-3.471,4.235-3.68,10.761-3.68,20.272s.208,16.037,3.68,20.272a12.977,12.977,0,0,0,10.83,5,12.889,12.889,0,0,0,9.511-3.541c2.569-2.43,4.235-6.387,4.443-11.108h-9.858a9.363,9.363,0,0,1-.764,3.818,3.3,3.3,0,0,1-3.332,1.944,3.394,3.394,0,0,1-3.332-1.944c-1.18-2.291-1.319-8.47-1.319-14.44s.139-12.149,1.319-14.44a3.394,3.394,0,0,1,3.332-1.944,3.252,3.252,0,0,1,3.332,1.874,9.363,9.363,0,0,1,.764,3.818h9.858c-.208-4.721-1.874-8.609-4.443-11.038A12.889,12.889,0,0,0,412.783-35.28ZM428.2,14.705H438.47L440.067,7h11.386l1.6,7.706h10.275l-12.7-49.43H440.9ZM441.941-1.887l3.818-18.328,3.818,18.328Zm46.236-32.838h-26.52v8.886h8.331V14.705h9.858V-25.838h8.331Zm15.065,0h-9.858v49.43h9.858Zm20.688,49.985a12.977,12.977,0,0,0,10.83-5c3.471-4.235,3.68-10.761,3.68-20.272s-.208-16.037-3.68-20.272a12.977,12.977,0,0,0-10.83-5,12.977,12.977,0,0,0-10.83,5c-3.471,4.235-3.68,10.761-3.68,20.272s.208,16.037,3.68,20.272A12.977,12.977,0,0,0,523.931,15.261Zm0-8.886A3.394,3.394,0,0,1,520.6,4.431c-1.18-2.291-1.319-8.47-1.319-14.44s.139-12.149,1.319-14.44a3.394,3.394,0,0,1,3.332-1.944,3.394,3.394,0,0,1,3.332,1.944c1.18,2.291,1.319,8.47,1.319,14.44s-.139,12.149-1.319,14.44A3.394,3.394,0,0,1,523.931,6.374Zm49.43-41.1H563.5v24.16l-10.275-24.16H544.62v49.43h9.858V-9.454l10.483,24.16h8.4Z" transform="translate(20.959 60.386)" fill="#fff"/>
                            </g>
                        </svg>

                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="931.969"
                            height="68.383"
                            viewBox="0 0 931.969 68.383"
                            class="title-arrow-desktop"
                        >
                            <path
                                id="title-arrow"
                                d="M892.122,62.726l24.528-24.538H0v-8H916.662L892.123,5.657,897.78,0l34.189,34.178L897.781,68.383Z"
                                fill="#fff"
                            />
                        </svg>
                        <svg xmlns="http://www.w3.org/2000/svg" width="29.252" height="49.904" viewBox="0 0 29.252 49.904" class="title-arrow-mobile">
                            <g id="Group_3218" data-name="Group 3218" transform="translate(595.777 -1639.735) rotate(90)">
                                <path id="Union_6" data-name="Union 6" d="M21333.6-14241.587l9.791-9.8h-42.242v-4h42.246l-9.795-9.79,2.824-2.829,14.629,14.618-1.416,1.414-13.213,13.22Z" transform="translate(-19661.416 14834.535)" fill="#fff"/>
                            </g>
                        </svg>

                        <!-- <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="278.354"
                            height="29.252"
                            viewBox="0 0 278.354 29.252"
                            class="title-arrow-mobile"
                        >
                            <path
                                id="Union_6"
                                data-name="Union 6"
                                d="M21333.6-14241.587l9.791-9.8H21072.7v-4h270.7l-9.795-9.79,2.824-2.829,14.629,14.618-1.416,1.414-13.213,13.22Z"
                                transform="translate(-21072.703 14268.01)"
                                fill="#fff"
                            />
                        </svg> -->
                    </h1>
                </div>
                <div class="flex flex-col intro-container">
                    <div class="intro">
                        <div>
                            <h2>
                                See where the faculty of Education can take you
                            </h2>
                            <p>
                                Explore the degrees and programs available at
                                the Faculty of Education based on your
                                interests and goals
                            </p>
                        </div>
                        <button @click="start" class="button-start">
                            Start Exploring
                        </button>
                    </div>
                </div>
            </div>
            <div>
                <p>
                    Note: The program explorer is designed to help guide your search, and is not an advising tool.
                </p>
                <p>
                    Admissions requirements are provided on individual program pages.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Home",
        props: ["question"],
        methods: {
            start() {
                this.$router.push({
                    name: "pathway",
                    params: {
                        level: "0",
                    },
                });
            },
        },
    };
</script>

<style scoped>
    .home {
        background: var(--c-red);
        color: #fff;
        min-height: 100vh;
        display: flex;
        padding: 2rem 0;
    }

    .home-container {
        margin-top: auto;
        margin-bottom: auto;
        align-items: center;
    }

    .flex {
        display: flex;
        margin: 0 auto;
    }

    .flex-col {
        flex-direction: column;
    }

    .home-container > .flex {
        flex-direction: column;
    }

    @media (min-width: 1100px) {
        .home-container > .flex {
            flex-direction: row;
        }
    }

    .button-start {
        background: none;
        background: #fff;
        color: var(--c-red);
        text-transform: uppercase;
        font-size: 1.5rem;
        padding: 1rem 3rem;
        text-align: center;
        appearance: none;
        border: 1px solid #fff;
        font-family: var(--font-pdf);
        font-weight: bold;
        cursor: pointer;
        width: 100%;
    }

    .button-start:hover,
    .button-start:focus {
        background: var(--c-red);
        color: #fff;
    }

    h1 {
        font-family: var(--font-countach);
        text-transform: uppercase;
        position: relative;
        margin: 0;
        /* margin-bottom: -24px; */
    }

    .heading-svg {
        position: relative;
        height: auto;
        z-index: 5;
    }

    @media (max-width: 767px) {
        .heading-svg {
            width: clamp(200px, 100%, 280px);
        }
    }

    /* h1 .small {
        font-size: 24px;
        background: #a41b30;
        display: inline-block;
        padding: 12px 12px 8px;
        font-family: var(--font-pdf);
        font-weight: bold;
        line-height: 24px;
    }

    h1 .large {
        font-size: 79px;
        display: block;
        line-height: 79px;
        position: relative;
        z-index: 5;
    }

    h1 .large .top-span {
        line-height: 95px;
        padding-top: 0px;
    } */

    @media (min-width: 768px) {
        .heading-svg {
            width: clamp(600px, 40%, 500px);
            height: auto;
            z-index: 5;
            /* width: 100%; */
        }
    }

    @media (min-width: 1100px) {
        .h1-container {
            width: 60%;
            position: relative;
        }

        .heading-svg {
            width: clamp(300px, 100%, 90%);
        }
    }

    .title-arrow-desktop {
        display: none;
    }

    .title-arrow-mobile {
        position: absolute;
        /* transform: translate3d(0, -28px, 0); */
        z-index: 0;
        left: 0;
        bottom: -28px;
    }

    @media (min-width: 900px) {
        .title-arrow-desktop {
            /* display: block; */
            position: absolute;
            top: 88%;
            right: 0;
            width: 100%;
        }
    }

    @media (min-width: 1100px) {
        .title-arrow-desktop {
            display: block;
            top: 88%;
        }

        .title-arrow-mobile {
            display: none;
        }
    }

    @media (min-width: 1200px) {
        .title-arrow-desktop {
            top: 90%;
        }
    }

    .gap-4 {
        gap: 4rem;
        margin-bottom: 3rem;
    }

    @media (min-width: 900px) {
        .gap-4 {
            gap: 6rem;
        }
    }

    .intro-container {
        justify-content: flex-end;
        padding: 0;
        width: 100%;
    }

    @media (min-width: 1100px) {
        .intro-container {
            padding: 35px 40px 0;
            width: 40%;
        }

        .gap-4 {
            gap: 4rem;
        }
    }


    /* .intro > div {
        padding-left: 2rem;
    } */

    @media (min-width: 1100px) {
        .intro > div {
            padding-left: 0;
        }

        .intro {
            max-width: 340px;
        }
    }

    .intro-container h2 {
        text-transform: uppercase;
        font-size: 25px;
        font-family: var(--font-pdf);
        line-height: 1;
        margin-top: 0;
    }

    .intro-container p {
        font-size: 18px;
        margin-bottom: 4rem;
    }


</style>
